import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { resetPassword } from './helpers';

import AccountResetPassword from './AccountResetPassword';

const propTypes = {
  match: PropTypes.object.isRequired,
};

class AccountResetPasswordContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        state: {
          password: '',
        },
        saved: false,
        message: '',
      },
    };
  }

  handleInputChange = e => {
    const { target } = e;

    const newState = update(this.state, {
      form: {
        state: {
          [target.name]: {
            $set: target.value,
          },
        },
      },
    });

    this.setState(newState);
  };

  handleSubmit = async e => {
    const { resetPasswordToken } = this.props.match.params;
    const {
      form: { state },
    } = this.state;

    const resetState = update(this.state, {
      form: {
        message: {
          $set: '',
        },
        saved: {
          $set: false,
        },
      },
    });

    this.setState(resetState);

    e.preventDefault();

    if (!state.password || !state.password.length) {
      const newState = update(this.state, {
        form: {
          message: {
            $set: 'You need to supply a new password!',
          },
        },
      });

      return this.setState(newState);
    }

    if (!resetPasswordToken || !resetPasswordToken.length) {
      const newState = update(this.state, {
        form: {
          message: {
            $set: 'Password reset token invalid. Please request a new token.',
          },
        },
      });

      return this.setState(newState);
    }

    const data = Object.assign({}, state);

    const submittedPasswordReset = await resetPassword(
      data,
      resetPasswordToken,
    );

    if (!submittedPasswordReset) {
      const newState = update(this.state, {
        form: {
          message: {
            $set: 'Something went wrong. If this error persists, please contact support.',
          },
        },
      });

      return this.setState(newState);
    }

    if (submittedPasswordReset.message) {
      const newState = update(this.state, {
        form: {
          message: {
            $set: submittedPasswordReset.message,
          },
        },
      });

      this.setState(newState);
      return;
    }

    const newState = update(this.state, {
      form: {
        saved: {
          $set: true,
        },
      },
    });

    this.setState(newState);
  };

  render() {
    return (
      <AccountResetPassword
        form={this.state.form}
        handleInputChange={this.handleInputChange}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

AccountResetPasswordContainer.propTypes = propTypes;

export default AccountResetPasswordContainer;
